import { Suspense, lazy } from 'react';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { FEATURE_TOUR_SEEN_KEY } from './constants';

const FeatureTour = lazy(() => import('components/FeatureTour/FeatureTour'));

export function FeatureTourLazy() {
  const [isHidden] = useLocalStorage(FEATURE_TOUR_SEEN_KEY);

  if (isHidden) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <FeatureTour />
    </Suspense>
  );
}
